document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("button[pi-collection-swatch]").forEach(function (el) {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      var piCollectionImage = e.target.dataset.piCollectionImage;
      var piCollectionUrl = e.target.dataset.piCollectionUrl;
      var parentElement = e.target.closest(".pi-collections__card-wrapper");
      parentElement.querySelectorAll("button[pi-collection-swatch] span").forEach(function (buttonswatch) {
        buttonswatch.removeAttribute("active");
      });
      e.target.querySelector("span").setAttribute("active", "");

      parentElement.querySelector("[pi-collection-swatch-image]").src = piCollectionImage;
      parentElement.querySelector("[pi-collection-swatch-image]").srcset = piCollectionImage;

      parentElement.querySelector("[pi-collection-image-url]").setAttribute("href", piCollectionUrl);
    });
  });
});